import { appCreateSlice } from '@store/rtk';

import { WithdrawalsState } from './types';
import { withdrawalsAddExchangeRateReducer } from './withdrawals-add-exchange-rate';
import { withdrawalsAddLimitReducer } from './withdrawals-add-limit';
import { withdrawalsDeleteExchangeRateReducer } from './withdrawals-delete-exchange-rate';
import { withdrawalsDeleteLimitReducer } from './withdrawals-delete-limit';
import { withdrawalsReceiveGetDistributionBalanceListReducer } from './withdrawals-receive-get-distribution-balance-list';
import { withdrawalsReceiveGetDistributionSettingsListReducer } from './withdrawals-receive-get-distribution-settings-list';
import { withdrawalsReceiveGetExchangeRatesReducer } from './withdrawals-receive-get-exchange-rates';
import { withdrawalsReceiveGetLimitsReducer } from './withdrawals-receive-get-limits';
import { withdrawalsReceiveGetListReducer } from './withdrawals-receive-get-list';
import { withdrawalsReceiveSetExchangeRatesReducer } from './withdrawals-receive-set-exchange-rates';
import { withdrawalsReceiveSetLimitsReducer } from './withdrawals-receive-set-limits';
import { withdrawalsReceiveSetOrderStatusReducer } from './withdrawals-receive-set-order-status';
import { withdrawalsResetExchangeRatesProcessedItemsReducer } from './withdrawals-reset-exchange-rates-processed-items';
import { withdrawalsResetLimitsProcessedItemsReducer } from './withdrawals-reset-limits-processed-items';
import { withdrawalsSetAggregatorStateReducer } from './withdrawals-set-aggregator-state';
import { withdrawalsSetBalanceReducer } from './withdrawals-set-balance';
import { withdrawalsSetDistributionSettingsProcessedItemsReducer } from './withdrawals-set-distribution-settings-processed-items';
import { withdrawalsSetExchangeRateAmountReducer } from './withdrawals-set-exchange-rate-amount';
import { withdrawalsSetExchangeRatesCurrencyReducer } from './withdrawals-set-exchange-rates-currency';
import { withdrawalsSetLimitsAggregatorReducer } from './withdrawals-set-limits-aggregator';
import { withdrawalsSetLimitsCurrencyReducer } from './withdrawals-set-limits-currency';
import { withdrawalsSetLimitsLimitAmountReducer } from './withdrawals-set-limits-limit-amount';
import { withdrawalsSetLimitsLimitTypeReducer } from './withdrawals-set-limits-limit-type';
import { withdrawalsSetLimitsProcessedItemsReducer } from './withdrawals-set-limits-processed-items';
import { withdrawalsSetPaymentSystemDistributionPercentReducer } from './withdrawals-set-payment-system-distribution-pecent';
import { withdrawalsSetPaymentSystemStateReducer } from './withdrawals-set-payment-system-state';

export const withdrawalsDefaultState: WithdrawalsState = {
  withdrawalsList: {
    items: undefined,
    totalCount: 0,
  },
  withdrawalsDistributionSettingsItems: undefined,
  withdrawalsDistributionSettingsProcessedItems: {},
  withdrawalsDistributionBalanceItems: undefined,
  withdrawalsLimits: undefined,
  withdrawalsLimitsProcessedItems: undefined,
  withdrawalsExchangeRates: undefined,
  withdrawalsExchangeRatesProcessedItems: undefined,
};

const withdrawalsSlice = appCreateSlice({
  name: 'withdrawals',
  initialState: withdrawalsDefaultState,
  reducers: {
    withdrawalsReceiveGetList: withdrawalsReceiveGetListReducer,
    withdrawalsReceiveSetOrderStatus: withdrawalsReceiveSetOrderStatusReducer,
    withdrawalsReceiveGetDistributionSettingsList:
      withdrawalsReceiveGetDistributionSettingsListReducer,
    withdrawalsReceiveGetDistributionBalanceList:
      withdrawalsReceiveGetDistributionBalanceListReducer,
    withdrawalsSetAggregatorState: withdrawalsSetAggregatorStateReducer,
    withdrawalsSetPaymentSystemState: withdrawalsSetPaymentSystemStateReducer,
    withdrawalsSetPaymentSystemDistributionPercent:
      withdrawalsSetPaymentSystemDistributionPercentReducer,
    withdrawalsSetDistributionSettingsProcessedItems:
      withdrawalsSetDistributionSettingsProcessedItemsReducer,
    withdrawalsSetBalance: withdrawalsSetBalanceReducer,
    withdrawalsReceiveGetLimits: withdrawalsReceiveGetLimitsReducer,
    withdrawalsSetLimitsProcessedItems:
      withdrawalsSetLimitsProcessedItemsReducer,
    withdrawalsAddLimit: withdrawalsAddLimitReducer,
    withdrawalsDeleteLimit: withdrawalsDeleteLimitReducer,
    withdrawalsResetLimitsProcessedItems:
      withdrawalsResetLimitsProcessedItemsReducer,
    withdrawalsSetLimitsAggregator: withdrawalsSetLimitsAggregatorReducer,
    withdrawalsSetLimitsCurrency: withdrawalsSetLimitsCurrencyReducer,
    withdrawalsSetLimitsLimitType: withdrawalsSetLimitsLimitTypeReducer,
    withdrawalsSetLimitsLimitAmount: withdrawalsSetLimitsLimitAmountReducer,
    withdrawalsReceiveSetLimits: withdrawalsReceiveSetLimitsReducer,
    withdrawalsReceiveGetExchangeRates:
      withdrawalsReceiveGetExchangeRatesReducer,
    withdrawalsResetExchangeRatesProcessedItems:
      withdrawalsResetExchangeRatesProcessedItemsReducer,
    withdrawalsReceiveSetExchangeRates:
      withdrawalsReceiveSetExchangeRatesReducer,
    withdrawalsAddExchangeRate: withdrawalsAddExchangeRateReducer,
    withdrawalsSetExchangeRatesCurrency:
      withdrawalsSetExchangeRatesCurrencyReducer,
    withdrawalsDeleteExchangeRate: withdrawalsDeleteExchangeRateReducer,
    withdrawalsSetExchangeRateAmount: withdrawalsSetExchangeRateAmountReducer,
  },
});

export const {
  actions: {
    withdrawalsReceiveGetList,
    withdrawalsReceiveSetOrderStatus,
    withdrawalsReceiveGetDistributionSettingsList,
    withdrawalsReceiveGetDistributionBalanceList,
    withdrawalsSetAggregatorState,
    withdrawalsSetPaymentSystemState,
    withdrawalsSetPaymentSystemDistributionPercent,
    withdrawalsSetDistributionSettingsProcessedItems,
    withdrawalsSetBalance,
    withdrawalsReceiveGetLimits,
    withdrawalsSetLimitsProcessedItems,
    withdrawalsAddLimit,
    withdrawalsDeleteLimit,
    withdrawalsResetLimitsProcessedItems,
    withdrawalsSetLimitsAggregator,
    withdrawalsSetLimitsCurrency,
    withdrawalsSetLimitsLimitType,
    withdrawalsSetLimitsLimitAmount,
    withdrawalsReceiveSetLimits,
    withdrawalsReceiveGetExchangeRates,
    withdrawalsResetExchangeRatesProcessedItems,
    withdrawalsReceiveSetExchangeRates,
    withdrawalsAddExchangeRate,
    withdrawalsSetExchangeRatesCurrency,
    withdrawalsDeleteExchangeRate,
    withdrawalsSetExchangeRateAmount,
  },
  reducer: withdrawalsReducer,
} = withdrawalsSlice;
